import { gql } from '@apollo/client'

export const SAVE_EXCHANGE_RATE_MUTATION = gql`
  mutation SaveExchangeRate($input: SaveExchangeRateInput!) {
    saveExchangeRate(input: $input) {
      message
    }
  }
`

export const EXCHANGE_RATE_LIST_QUERY = gql`
  query ExchangeRateList($input: ExchangeRateInput!) {
    exchangeRateList(input: $input) {
      currency
      dataForEachDate {
        date
        exchangeRate
      }
    }
  }
`
